import { FILETYPE_MAP } from '@shared/constants';
import { FileTypes } from '@shared/interfaces';

/**
 * Get file types based on the selected content type
 *
 * @param option A single string of the content type
 *
 * @remarks
 * This function is used to get the file types based on the selected content type.
 *
 * Current supported types are as follows:
 * - images
 * - videos
 *
 * Add your type inside the FILETYPE_MAP constant in @shared/constants/filetype.constant.ts
 *
 * @returns An array of file types'
 *
 * @example
 * ```typescript
 * const fileTypes = getFileTypes('images');
 * console.log(fileTypes) // ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/svg+xml']
 * ```
 */
export function getFileTypes(option: FileTypes): string[] {
    return FILETYPE_MAP[option];
}
